module.exports = __webpack_public_path__ + "img/ctrl-swap-root-stub-up-+i.3c53b798.svg";